/* Eloura Living: refinements */
(function () {
  'use strict';
  var d = document;
  var EL = window.EL || {};
  var money = function (cents) {
    var v = (Number(cents) || 0) / 100;
    var f = EL.moneyFormat || '${{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return Math.round(v).toLocaleString('en-US');
      if (k === 'amount_with_comma_separator') return v.toFixed(2).replace('.', ',');
      return v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }).replace(/<[^>]*>/g, '');
  };

  /* Rotating announcement */
  var ann = d.querySelector('[data-announce]');
  if (ann) {
    var msgs = ann.querySelectorAll('span');
    var i = 0;
    if (msgs.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setInterval(function () {
        var cur = msgs[i];
        cur.classList.remove('is-active');
        cur.classList.add('is-out');
        setTimeout(function () { cur.classList.remove('is-out'); }, 800);
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, 4200);
    }
  }

  /* Variant picker */
  var dataEl = d.getElementById('VariantData');
  var form = d.getElementById('ProductForm');
  if (!dataEl || !form) return;
  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var fieldsets = Array.prototype.slice.call(form.querySelectorAll('.opt'));
  if (!fieldsets.length) return;
  var idInput = form.querySelector('input[name=id]');
  var addBtn = form.querySelector('[name=add]');
  var priceEl = d.querySelector('[data-price]');
  var stickyPrice = d.querySelector('[data-sticky-price]');
  var stickyBtn = d.querySelector('[data-sticky-atc] button');
  var track = d.querySelector('[data-gallery-track]');
  var matches = function (v, sel) { return v.options.every(function (o, j) { return o === sel[j]; }); };
  var selected = function () { return fieldsets.map(function (f) { var c = f.querySelector('input:checked'); return c ? c.value : null; }); };
  var goTo = function (idx, smooth) {
    if (!track || idx < 0) return;
    var s = track.querySelectorAll('.pdp__slide')[idx];
    if (s) track.scrollTo({ left: s.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
  };
  var update = function (smooth) {
    var sel = selected();
    fieldsets.forEach(function (f, i) {
      var l = f.querySelector('[data-opt-label]');
      if (l) l.textContent = sel[i] || '';
      f.querySelectorAll('input').forEach(function (inp) {
        var test = sel.slice(); test[i] = inp.value;
        var ok = variants.some(function (x) { return x.available && matches(x, test); });
        inp.closest('.pill').classList.toggle('is-off', !ok);
      });
    });
    var v = variants.filter(function (x) { return matches(x, sel); })[0];
    if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; if (stickyBtn) stickyBtn.disabled = true; return; }
    idInput.value = v.id;
    if (priceEl) priceEl.textContent = money(v.price);
    if (stickyPrice) stickyPrice.textContent = money(v.price);
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
    if (stickyBtn) stickyBtn.disabled = !v.available;
    if (smooth !== null) {
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState(null, '', u.toString()); } catch (e) {}
      goTo(v.media, smooth);
    }
  };
  form.addEventListener('change', function (e) { if (e.target.closest('.opt')) update(true); });
  update(null);
  if (track) {
    var start = parseInt(track.getAttribute('data-start') || '0', 10);
    if (start > 0) window.addEventListener('load', function () { goTo(start, false); });
  }
})();
